import styled from 'styled-components';
import { ReactComponent as CheckedSvg } from '../../assets/EnvSelectorChecked.svg';
import { ReactComponent as UncheckedSvg } from '../../assets/EnvSelectorUnchecked.svg';
import { ReactComponent as ClientSvg } from '../../assets/EnvIconCV.svg';
import { ReactComponent as ManageSvg } from '../../assets/EnvIconES.svg';


export const CheckedIcon = styled(CheckedSvg)`
  width: 10%;
  float: right;
  height: auto;
`;

export const UncheckedIcon = styled(UncheckedSvg)`
  width: 10%;
  float: right;
  height: auto;
`;

export const ClientIcon = styled(ClientSvg)`
  width: auto;
  height: 50%;
`;

export const ManageIcon = styled(ManageSvg)`
  width: auto;
  height: 50%;
`;

export const EnvIconCodeText = styled.div`
  width: auto;
  height: 50%;
`;


export const EnvIconContainer = styled.div`
  width: 20%;
  float: left;
  height: 100%;
`;

export const EnvItemContainer = styled.div`
  width: 100%;
  display: flex;
  height: 100px;
  margin-bottom: 15px;

  img {
    width: 30%;
  }


`;

export const ItemDetails = styled.div`
  width: 70%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 10px 10px;

  span {
    float: left;
    width: 100%;
    font-size: 16px;
  }
`;